export default __webpack_public_path__ + "static/media/90943e0b579f5714.a5cf0eedcccafda6e55909ea0bb42e73.svg";